import { api } from '@/shared/api/axios';

const base = (depId) => `/deployments/${depId}/notifications`;

function unwrapList(r) {
  const d = r.data;
  return Array.isArray(d) ? d : Array.isArray(d?.data) ? d.data : [];
}

export const notificationsApi = {
  list: (depId) => api.get(base(depId)).then(unwrapList),
  get: (depId, id) => api.get(`${base(depId)}/${id}`).then((r) => r.data?.data ?? r.data),
  create: (depId, payload) => api.post(base(depId), payload).then((r) => r.data?.data ?? r.data),
  update: (depId, id, payload) => api.patch(`${base(depId)}/${id}`, payload).then((r) => r.data?.data ?? r.data),
  delete: (depId, id) => api.delete(`${base(depId)}/${id}`).then((r) => r.data),
  // Lightweight enable/pause toggle — only sends { enabled }.
  toggle: (depId, id, enabled) => api.patch(`${base(depId)}/${id}`, { enabled }).then((r) => r.data?.data ?? r.data),
};

export const notificationTemplatesApi = {
  // Global catalog. Optional `channel` (email|whatsapp) and `event` filters.
  // One template per (event, channel).
  list: ({ channel, event } = {}) => api
    .get('/notification-templates', { params: { ...(channel ? { channel } : {}), ...(event ? { event } : {}) } })
    .then(unwrapList),
};

export const notificationEventsApi = {
  // Catalog of trigger events the platform can fire. [{ key, label, group }].
  list: () => api.get('/notification-events').then(unwrapList),
};
